import $ from 'jquery';
import * as math from 'mathjs';

require('./aufzeichnungenEditData');

/**
 * Initialize Link
 * @param element
 */
window.intializeLink = function(element) {
  $(element).find('.row > *:not(:last-child)').on('click', function() {
    const category = $(this).closest('.row').data('category');
    const id = $(this).closest('.row').data('id');
    const step = $(this).closest('.row').data('last-step');

    openAufzeichnung(category, id, step);
    return false;
  });
};

/**
 * intializeLinkRowTable
 * @param element
 * @param uriBefore
 */
window.intializeLinkRowTable = function(element, uriBefore = '') {
  $(element).find('.row[data-category][data-id][data-last-step], .row-table[data-category][data-id][data-last-step]').on('click', function() {
    const category = $(this).data('category');
    const id = $(this).data('id');
    const step = $(this).data('last-step');
    const showError = $(this).data('show-error');

    if (category === 'oekologischeMassnahme') {
      openOekomassname(id, uriBefore);
    } else {
      openAufzeichnung(category, id, step, uriBefore, showError);
    }

    return false;
  });

  $(element).find('.row[data-category], .row-table[data-category]').on('click', function() {
    const category = $(this).data('category');

    if (category === 'oekologischeMassnahme') {
      openOekomassname(0, uriBefore);
    }
  });
};

/**
 * open Aufzeichnung
 * @param category
 * @param id
 * @param step
 * @param uriBefore
 * @param showError
 */
window.openAufzeichnung = function(category, id, step, uriBefore = '', showError = 0) {
  window.location = '/aufzeichnungen/' + category + '/' + id + '?step=' + step + (uriBefore !== '' ? '&uriBefore=' + uriBefore : '') + (showError === 1 ? '&showError=1' : '');
};

/**
 * open Oekomassname
 * @param id
 * @param uriBefore
 */
window.openOekomassname = function(id, uriBefore) {
  if (id > 0) {
    window.location = '/vegetationErnte/oekologischeMassnahmen/' + id + (uriBefore !== '' ? '&uriBefore=' + uriBefore : '');
  } else {
    window.location = '/vegetationErnte/oekologischeMassnahmen/' + (uriBefore !== '' ? '?uriBefore=' + uriBefore : '');
  }
};

/**
 * Check Status
 * @param element
 */
window.checkStatus = function(element) {
  const objVal = $(element).val();
  const checkCheckbox = $('.checkCheckbox');
  if (objVal > 100) {
    checkCheckbox.removeAttr('disabled');
  } else {
    checkCheckbox.attr('disabled', 'disabled');
    checkCheckbox.removeAttr('checked');
  }
};

/**
 * Trigger Level
 */
window.triggerLevel = function() {
  const firstTrigger = $('#show-first-level');
  const secondTrigger = $('#show-second-level');
  const thirdTrigger = $('#show-third-level');
  firstTrigger.on('click', function() {
    if (firstTrigger.hasClass('active')) {
      triggerTreeGroup('', '.tree-item.first-level,.tree-item.second-level,.tree-item.third-level');
      firstTrigger.removeClass('active');
    } else {
      triggerTreeGroup('.tree-item.first-level', '.tree-item.second-level,.tree-item.third-level');
      firstTrigger.addClass('active');
    }
    secondTrigger.removeClass('active');
    thirdTrigger.removeClass('active');
    return false;
  });
  secondTrigger.on('click', function() {
    if (secondTrigger.hasClass('active')) {
      triggerTreeGroup('.tree-item.first-level', '.tree-item.second-level,.tree-item.third-level');
      secondTrigger.removeClass('active');
    } else {
      triggerTreeGroup('.tree-item.first-level,.tree-item.second-level', '.tree-item.third-level');
      secondTrigger.addClass('active');
    }
    firstTrigger.addClass('active');
    thirdTrigger.removeClass('active');
    return false;
  });
  thirdTrigger.on('click', function() {
    if (thirdTrigger.hasClass('active')) {
      triggerTreeGroup('.tree-item.first-level,.tree-item.second-level', '.tree-item.third-level');
      thirdTrigger.removeClass('active');
    } else {
      triggerTreeGroup('.tree-item.first-level,.tree-item.second-level,.tree-item.third-level', '');
      thirdTrigger.addClass('active');
    }
    firstTrigger.addClass('active');
    secondTrigger.addClass('active');
    return false;
  });
};

/**
 * Trigger Level Checkboxes
 */
window.triggerLevelCheckboxes = function(isTeilspritzungDialog = false) {
  const allTrigger = $('#check-all');
  const primaryTrigger = $('.check_primary');
  const secondaryTrigger = $('.check_secondary');
  const tertiaryTrigger = $('.check_tertiary');
  const selectTeilspritzungTree = $('#tree-select-teilspritzung-abschnitte');

  // Alle Anlagen und Abschnitte eines Betriebs auswählen
  primaryTrigger.on('click', function(event) {
    event.stopPropagation();
    if ($(this).attr('onclick')) {
      return;
    }

    const row = $(this).closest('.first-level');
    const primaryID = row.attr('data-primary');

    if ($(this).is(':checked')) {
      $('.second-level.p' + primaryID).find('.check_secondary').not(':disabled').prop('checked', true);
      $('.third-level.p' + primaryID).find('.check_tertiary').not(':disabled').prop('checked', true);
    } else {
      if (isTeilspritzungDialog) {
        selectTeilspritzungTree.find('.third-level.p' + primaryID).find('.check_tertiary:checked').prop('checked', false).trigger('deselect');
        selectTeilspritzungTree.find('.second-level.p' + primaryID).find('.check_secondary').prop('checked', false).trigger('deselect');
      } else {
        const secondaryElement = $('.second-level.p' + primaryID);
        const tertiaryElement = $('.third-level.p' + primaryID);

        secondaryElement.find('.check_secondary:checked').prop('checked', false).trigger('deselect');
        tertiaryElement.find('.check_tertiary:checked').prop('checked', false).trigger('deselect');

        $('.tr_details.p' + primaryID + ' table .section_detail_mittel').remove();
        if (typeof updateTeilspritzungen == 'function') {
          updateTeilspritzungen(primaryID);
        }
      }
    }

    if (typeof checkboxClicked == 'function') {
      checkboxClicked(false, isTeilspritzungDialog);
    }
    checkCheckboxes();
  });

  // Alle Abschnitte einer Anlage auswählen
  secondaryTrigger.on('click', function(event) {
    event.stopPropagation();
    if ($(this).attr('onclick')) {
      return;
    }
    const row = $(this).closest('.second-level');
    const primaryID = row.attr('data-primary');
    const secondaryID = row.attr('data-secondary');

    const secondaryElement = $('.second-level[data-primary="' + primaryID + '"]');
    const tertiaryElement = $('.third-level.p' + primaryID + '.s' + secondaryID);
    if ($(this).is(':checked')) {
      tertiaryElement.find('.check_tertiary').not(':disabled').prop('checked', true);

      // Wenn eine Anlage einzeln ausgewählt wird, so soll auch der dazugehörige Betrieb ausgewählt werden
      $('.first-level[data-primary="' + primaryID + '"]').find('.check_primary').not(':disabled').prop('checked', true);
    } else {
      if (isTeilspritzungDialog) {
        selectTeilspritzungTree.find('.third-level.p' + primaryID + '.s' + secondaryID).find('.check_tertiary:checked').prop('checked', false).trigger('deselect');
        if (selectTeilspritzungTree.find('.second-level[data-primary="' + primaryID + '"]').find('.check_secondary:checked').length === 0) {
          selectTeilspritzungTree.find('.first-level[data-primary="' + primaryID + '"]').find('.check_primary:checked').prop('checked', false);
        }
      } else {
        tertiaryElement.find('.check_tertiary:checked').prop('checked', false).trigger('deselect');
        // Wenn keine andere Anlage ausgewählt ist, so soll der dazugehörige Betrieb auch wieder abgewählt werden
        if (secondaryElement.find('.check_secondary:checked').length === 0) {
          $('.first-level[data-primary="' + primaryID + '"]').find('.check_primary:checked').prop('checked', false);
        }

        $('.tr_details.s' + secondaryID + ' table .section_detail_mittel').remove();
        if (typeof updateTeilspritzungen == 'function') {
          updateTeilspritzungen(primaryID, secondaryID);
        }
      }
    }

    if (typeof checkboxClicked == 'function') {
      checkboxClicked(false, isTeilspritzungDialog);
    }
    checkCheckboxes();
  });

  // Wenn ein Abschnitt einzeln ausgewählt wird, so soll auch die dazugehörige Anlage und der dazugehörige Betrieb ausgewählt werden
  tertiaryTrigger.on('click', function(event) {
    event.stopPropagation();
    if ($(this).attr('onclick')) {
      return;
    }

    const row = $(this).closest('.third-level');
    const primaryID = row.attr('data-primary');
    const secondaryID = row.attr('data-secondary');
    const tertiaryID = row.attr('data-tertiary');

    if ($(this).is(':checked')) {
      $('.first-level[data-primary="' + primaryID + '"]').find('.check_primary').not(':disabled').prop('checked', true);
      $('.second-level[data-primary="' + primaryID + '"][data-secondary="' + secondaryID + '"]').find('.check_secondary').not(':disabled').prop('checked', true);
    } else {
      $(this).trigger('deselect');
      if (isTeilspritzungDialog) {
        if (selectTeilspritzungTree.find('.third-level[data-secondary="' + secondaryID + '"]').find('.check_tertiary:checked').length === 0) {
          selectTeilspritzungTree.find('.second-level[data-secondary="' + secondaryID + '"]').find('.check_secondary:checked').prop('checked', false);
        }
        if (selectTeilspritzungTree.find('.second-level[data-primary="' + primaryID + '"]').find('.check_secondary:checked').length === 0) {
          selectTeilspritzungTree.find('.first-level[data-primary="' + primaryID + '"]').find('.check_primary:checked').prop('checked', false);
        }
      } else {
        // Wenn kein anderer Abschnitt ausgewählt ist, so soll die dazugehörige Anlage auch wieder abgewählt werden
        if ($('.third-level[data-secondary="' + secondaryID + '"]').find('.check_tertiary:checked').length === 0) {
          $('.second-level[data-secondary="' + secondaryID + '"]').find('.check_secondary:checked').prop('checked', false);
        }

        // Wenn keine andere Anlage ausgewählt ist, so soll der dazugehörige Betrieb auch wieder abgewählt werden
        if ($('.second-level[data-primary="' + primaryID + '"]').find('.check_secondary:checked').length === 0) {
          $('.first-level[data-primary="' + primaryID + '"]').find('.check_primary:checked').prop('checked', false);
        }

        $('.tr_details.t' + tertiaryID + ' table .section_detail_mittel').remove();
        if (typeof updateTeilspritzungen == 'function') {
          updateTeilspritzungen(primaryID, secondaryID, tertiaryID);
        }
      }
    }

    if (typeof checkboxClicked == 'function') {
      checkboxClicked(false, isTeilspritzungDialog);
    }
    checkCheckboxes();
  });

  // Alle auswählen
  allTrigger.on('click', function(event) {
    event.stopPropagation();
    if ($(this).attr('onclick')) {
      return;
    }

    if ($(this).is(':checked')) {
      $('.check_primary:not(.display-none)').not(':disabled').prop('checked', true);
      $('.check_secondary:not(.display-none)').not(':disabled').prop('checked', true);
      $('.check_tertiary:not(.display-none)').not(':disabled').prop('checked', true);
    } else {
      $('.check_primary:not(.display-none):checked').prop('checked', false);
      $('.check_secondary:not(.display-none):checked').prop('checked', false);
      $('.check_tertiary:not(.display-none):checked').prop('checked', false).trigger('deselect');

      $('.tr_details table .section_detail_mittel').remove();
    }

    if (typeof checkboxClicked == 'function') {
      checkboxClicked();
    }
  });

  /**
   * Checkbox "Alle markieren"
   */
  window.checkCheckboxes = function() {
    if ($('.check_section').not(':disabled').not(':checked').length === 0) {
      allTrigger.prop('checked', true);
    } else {
      allTrigger.prop('checked', false);
    }
  };

  /**
   * checkboxClicked
   * @param firstLoad
   * @param isTeilspritzung
   */
  window.checkboxClicked = function(firstLoad, isTeilspritzung = false) {
    const triggerSubmit = $('#trigger-submit');
    const autoloaderElement = $('.form-record');

    // Spritzung
    if (MODULE_FILE === 'spritzung') {
      if(!isTeilspritzung) {
        triggerSubmit.attr('disabled', 'disabled').addClass('no-change-disabled');
        insertAutoLoader(autoloaderElement);
        setTimeout(function() {
          const returnData = spritzung_calc(spritzung_buildAbschnittData(isTeilspritzung), {
            type: 'RESET_BRUEHE',
            firstLoad: firstLoad,
          });
          if (returnData) {
            triggerSubmit.removeAttr('disabled').removeClass('no-change-disabled');
            removeAutoLoader();
          }
        }, 500);
      }
    }

    // Duengung
    if (MODULE_FILE === 'duengung') {
      triggerSubmit.attr('disabled', 'disabled').addClass('no-change-disabled');
      insertAutoLoader(autoloaderElement);

      const returnData = duengung_calc(duengung_buildAbschnittData(), {
        type: 'RESET_DUENGUNG_BRUEHE',
        firstLoad: firstLoad,
      });
      if (returnData) {
        duengung_recalcRowMittel();

        triggerSubmit.removeAttr('disabled');
        removeAutoLoader();
      }
    }

    // Herbizid
    if (MODULE_FILE === 'herbizidBehandlung') {
      triggerSubmit.attr('disabled', 'disabled').addClass('no-change-disabled');
      insertAutoLoader(autoloaderElement);

      setTimeout(function() {
        const returnData = herbizid_calc(herbizid_buildAbschnittData(), {
          type: 'RESET_HERBIZID_BRUEHE',
          firstLoad: firstLoad,
        });
        if (returnData) {
          herbizid_recalcRowMittel();

          triggerSubmit.removeAttr('disabled');
          removeAutoLoader();
        }
      }, 500);
    }

    // Verwirrung
    if (MODULE_FILE === 'verwirrung') {
      triggerSubmit.attr('disabled', 'disabled').addClass('no-change-disabled');
      insertAutoLoader(autoloaderElement);

      const returnData = verwirrung_calc(verwirrung_buildAbschnittData(), {
        type: 'RESET_VERWIRRUNG_BRUEHE',
        firstLoad: firstLoad,
      });
      if (returnData) {
        verwirrung_recalcRowMittel();

        triggerSubmit.removeAttr('disabled');
        removeAutoLoader();
      }
    }

    // AndereMassnahmen
    if (MODULE_FILE === 'andereMassnahmen') {
      triggerSubmit.attr('disabled', 'disabled').addClass('no-change-disabled');
      insertAutoLoader(autoloaderElement);

      const returnData = andereMassnahmen_calc(andereMassnahmen_buildAbschnittData(), {
        type: 'RESET_ANDERE_MASSNAHMEN_BRUEHE',
        firstLoad: firstLoad,
      });
      if (returnData) {
        andereMassnahmen_recalcRowMittel();

        triggerSubmit.removeAttr('disabled');
        removeAutoLoader();
      }
    }

    // Feldkontrollen
    if (MODULE_FILE === 'feldkontrollen') {
      triggerSubmit.attr('disabled', 'disabled').addClass('no-change-disabled');
      insertAutoLoader(autoloaderElement);

      const returnData = feldkontrollen_calc(feldkontrollen_buildAbschnittData(), {
        type: 'RESET_FELDKONTROLLEN_BRUEHE',
        firstLoad: firstLoad,
      });
      if (returnData) {
        feldkontrollen_recalcRowMittel();

        triggerSubmit.removeAttr('disabled');
        removeAutoLoader();
      }
    }

    // Bewässerung
    if (MODULE_FILE === 'bewaesserung') {
      triggerSubmit.attr('disabled', 'disabled').addClass('no-change-disabled');
      insertAutoLoader(autoloaderElement);

      bewaesserung_recalc();

      const returnData = bewaesserung_calc(bewaesserung_buildAbschnittData(), {
        type: 'RESET_BEWAESSERUNG',
        firstLoad: firstLoad,
      });
      if (returnData) {
        triggerSubmit.removeAttr('disabled');
        removeAutoLoader();
      }
    }
  };
};

/**
 * changeFlaechenAccordionTextColor
 * @param type
 * @param step
 */
window.changeFlaechenAccordionTextColor = function(type = 'warning', step = 2) {
  const accordionItem = $('.accordion__item[data-step="' + step + '"]');
  if (accordionItem.length > 0) {
    accordionItem.find('.accordion__item__title').addClass((type === 'warning' ? 'bg-warning' : 'bg-error'));
  }
};

/**
 * Toggle Kontrollen
 * @param element
 */
window.openControls = function(element) {
  if (event.target.tagName.toLowerCase() !== 'button' && event.target.tagName.toLowerCase() !== 'a') {
    $(element).toggleClass('control-row--show').nextUntil('.control-row').toggleClass('psm-check-row--show');
  }
};

/**
 * getCultureQuality
 * @returns {{cultures: *[], qualities: *[]}}
 */
window.getCultureQuality = function() {
  const cultures = [];
  $('#kultur-list').find('.culture-checkbox:checked').each(function() {
    const cultureID = Number($(this).val());
    if (cultures.indexOf(cultureID) === -1) {
      cultures.push(cultureID);
    }
  });

  const qualities = [];
  const factories = [];
  $('.check_section:checked').each(function() {
    // Qualities
    const qualityIDs = String($(this).closest('div.third-level').data('quality-ids'));
    const qualityList = qualityIDs.split(',');
    if (qualityList.length > 0) {
      $.each(qualityList, function(key, value) {
        const qualityID = Number(value);
        if (qualities.indexOf(qualityID) === -1) {
          qualities.push(qualityID);
        }
      });
    }

    // Factories
    const factoryID = String($(this).closest('div.third-level').data('factory-id'));
    if (factories.indexOf(factoryID) === -1) {
      factories.push(factoryID);
    }
  });

  return {
    cultures: cultures,
    qualities: qualities,
    factories: factories,
  };
};

/**
 * scrollToArea
 * @param step
 */
window.scrollToArea = function(step) {
  $('html, body').animate({
    scrollTop: $('div.accordion__item[data-step="' + step + '"]').offset().top - 50,
  }, 'fast');
};

/**
 * correctFlaechen
 * @param recordID
 * @param type
 * @param needResetBruehe
 */
window.correctFlaechen = function(recordID, type, needResetBruehe = false) {
  insertAutoLoader();

  $.ajax({
    url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.setAufzeichnungFlaechen',
    dataType: 'json',
    data: {
      recordID: recordID,
      type: type,
      needResetBruehe: needResetBruehe,
    },
  }).done(function() {
    location.reload();
  });
};

/**
 * wasserbedarfIdentisch
 * @param abschnitte
 * @returns {boolean}
 */
window.wasserbedarfIdentisch = function(abschnitte) {
  let wasseraufwand = undefined;
  for (let a of abschnitte) {
    if (!wasseraufwand) {
      wasseraufwand = roundWasseraufwand(a.bruehe * 10000 / a.flaeche);
    } else {
      if (math.compare(wasseraufwand, roundWasseraufwand(a.bruehe * 10000 / a.flaeche)) !== 0) {
        return false;
      }
    }
  }
  return true;
};

/**
 * findDosisProHl
 * @param abschnitte
 * @param dosisProHa
 * @returns {undefined}
 */
window.findDosisProHl = function(abschnitte, dosisProHa) {
  let dosisMin = undefined;
  abschnitte.forEach(a => {
    const dosisProHl = a.flaeche * dosisProHa / a.bruehe / 10000;
    if (!dosisMin) {
      dosisMin = dosisProHl;
    } else {
      dosisMin = math.min(dosisMin, dosisProHl);
    }
  });

  return dosisMin;
};

// ROUND DB

/**
 * Round Brühe
 * @param bruehe
 * @param roundUp
 * @returns {number|*}
 */
window.roundBruehe = function(bruehe, roundUp = true) {
  return round(bruehe, DECIMAL_PLACES_BRUEHE, roundUp);
};

/**
 * Round Mittelmenge
 * @param mittelmenge
 * @param roundUp
 * @returns {number|*}
 */
window.roundMittelmenge = function(mittelmenge, roundUp = true) {
  return round(mittelmenge, DECIMAL_PLACES_MITTELMENGE, roundUp);
};

/**
 * Round MittelmengeProHl
 * @param mittelmenge
 * @param roundUp
 * @returns {number|*}
 */
window.roundMittelmengeProHl = function(mittelmenge, roundUp = true) {
  return round(mittelmenge, DECIMAL_PLACES_MITTELMENGE_PRO_HL, roundUp);
};

/**
 * Round MittelmengeProHa
 * @param mittelmenge
 * @param roundUp
 * @returns {number|*}
 */
window.roundMittelmengeProHa = function(mittelmenge, roundUp = true) {
  return round(mittelmenge, DECIMAL_PLACES_MITTELMENGE_PRO_HA, roundUp);
};

/**
 * round Herbizidflaeche
 * @param herbizidflaeche
 * @param roundUp
 * @returns {number|*}
 */
window.roundHerbizidflaeche = function(herbizidflaeche, roundUp = true) {
  return round(herbizidflaeche, DECIMAL_PLACES_HERBIZIDFLAECHE, roundUp);
};

/**
 * roundAusliterung
 * @param auslituerng
 * @param roundUp
 * @returns {number|*}
 */
window.roundAusliterung = function(auslituerng, roundUp = true) {
  return round(auslituerng, DECIMAL_PLACES_AUSLITERUNG, roundUp);
};

/**
 * roundWasseraufwand
 * @param wasseraufwand
 * @returns {number|*}
 */
window.roundWasseraufwand = function(wasseraufwand) {
  return round(wasseraufwand, DECIMAL_PLACES_WASSERAUFWAND);
};

/**
 * roundWassermengeMillimeter
 * @param mittelmenge
 * @returns {number|*}
 */
window.roundWassermengeMillimeter = function(mittelmenge) {
  return round(mittelmenge, DECIMAL_PLACES_WASSERMENGE_MM);
};

// ROUND GUI

/**
 * Round Gui Brühe
 * @param bruehe
 * @returns {number|*}
 */
window.roundBrueheGui = function(bruehe) {
  return round(bruehe, DECIMAL_PLACES_BRUEHE_GUI);
};

/**
 * Round Gui Mittelmenge
 * @param mittelmenge
 * @returns {number|*}
 */
window.roundMittelmengeGui = function(mittelmenge) {
  return round(mittelmenge, DECIMAL_PLACES_MITTELMENGE_GUI);
};

/**
 * Round Gui Dosis pro hl
 * @param bruehe
 * @returns {number|*}
 */
window.roundDosisProHlGui = function(bruehe) {
  return round(bruehe, DECIMAL_PLACES_DOSIS_PR_HL_GUI);
};

/**
 * Truncate Gui Dosis pro hl
 * @param bruehe
 * @returns {*}
 */
window.truncateDosisProHlGui = function(bruehe) {
  return truncate(bruehe, DECIMAL_PLACES_DOSIS_PR_HL_GUI);
};

/**
 * Round Gui Mittelmenge pro ha
 * @param bruehe
 * @returns {number|*}
 */
window.roundMittelmengeProHaGui = function(bruehe) {
  return round(bruehe, DECIMAL_PLACES_MITTELMENGE_PRO_HA_GUI);
};

/**
 * round Gui HerbizidflaecheGui
 * @param herbizidflaeche
 * @returns {number|*}
 */
window.roundHerbizidflaecheGui = function(herbizidflaeche) {
  return round(herbizidflaeche, DECIMAL_PLACES_HERBIZIDFLAECHE_GUI);
};

/**
 * roundFlaecheHaGui
 * @param flaeche
 * @returns {number|*}
 */
window.roundFlaecheHaGui = function(flaeche) {
  return round(flaeche, DECIMAL_PLACES_FLAECHE_HA_GUI);
};

/**
 * round AusliterungGUui
 * @param ausliterung
 * @returns {number|*}
 */
window.roundAusliterungGui = function(ausliterung) {
  return round(ausliterung, DECIMAL_PLACES_AUSLITERUNG_GUI);
};

/**
 * roundWasseraufwandGui
 * @param wasseraufwand
 * @returns {number|*}
 */
window.roundWasseraufwandGui = function(wasseraufwand) {
  return round(wasseraufwand, DECIMAL_PLACES_WASSERAUFWAND_GUI);
};

/**
 * roundWassermengeMillimeterGui
 * @param mittelmenge
 * @returns {number|*}
 */
window.roundWassermengeMillimeterGui = function(mittelmenge) {
  return round(mittelmenge, DECIMAL_PLACES_WASSERMENGE_MM_GUI);
};

/**
 * roundDauerAbschnittGui
 * @param mittelmenge
 * @returns {number|*}
 */
window.roundDauerAbschnittGui = function(mittelmenge) {
  return round(mittelmenge, DECIMAL_PLACES_DAUER_ABSCHNITT_GUI);
};

/**
 * Round
 * @param num
 * @param places
 * @param roundUp
 * @returns {number|*}
 */
window.round = function(num, places, roundUp = true) {
  if (places < 0) {
    return num;
  }
  if (roundUp) {
    // return Math.round((num + Number.EPSILON) * Math.pow(10, places)) / Math.pow(10, places)
    return math.round(num, places);
  }
  return math.floor(num, places);
};

/**
 * Truncate
 * @param num
 * @param places
 * @returns {number|*}
 */
window.truncate = function(num, places) {
  if (places < 0) {
    return num;
  }
  return Math.trunc((num + Number.EPSILON) * Math.pow(10, places)) / Math.pow(10, places);
};

/**
 * sendAufteilungBrueheTankfuellungForm
 * @param element
 */
window.aufteilungBrueheTankfuellung_sendForm = function(element) {
  $(element).closest('form').submit();

  setTimeout(function() {
    ajaxDialog('close');
  }, 100);
};

/**
 * aufteilungBrueheTankfuellung_addVorschlag
 */
window.aufteilungBrueheTankfuellung_addVorschlag = function() {
  $('#vorschlag-fields').append($('#html-template').html());

  aufteilungBrueheTankfuellung_updateAufteilung();
  aufteilungBrueheTankfuellung_bind();
};

/**
 * aufteilungBrueheTankfuellung_deleteVorschlag
 * @param element
 */
window.aufteilungBrueheTankfuellung_deleteVorschlag = function(element) {
  const row = $(element).closest('div.row');
  row.remove();

  aufteilungBrueheTankfuellung_updateAufteilung();
  aufteilungBrueheTankfuellung_bind();
};

/**
 * aufteilungBrueheTankfuellung_updateAufteilung
 */
window.aufteilungBrueheTankfuellung_updateAufteilung = function() {
  let bruehmenge = parseFloat($('div[data-bruehmenge]').attr('data-bruehmenge'));
  let sumHl = 0;
  $('#vorschlag-fields input').each(function() {
    const hl = parseFloat(round($(this).val(), 2));
    sumHl = parseFloat(sumHl) + hl;
  });

  sumHl = round(sumHl, 2);
  bruehmenge = round(bruehmenge, 2);

  let difference = parseFloat(sumHl - bruehmenge);
  difference = round(difference, 2);

  const differenzHtml = $('#differenz');
  differenzHtml.removeClass('text-red');

  const anweisungSave = $('.anweisung-print');
  anweisungSave.removeAttr('disabled');

  if (difference < 0) {
    differenzHtml.addClass('text-red');
    anweisungSave.attr('disabled', 'disabled');
  } else if (difference > 0) {
    differenzHtml.addClass('text-red');
    anweisungSave.attr('disabled', 'disabled');
  } else {
    differenzHtml.removeClass('text-red');
    anweisungSave.removeAttr('disabled');
  }

  differenzHtml.html(numberFormat(difference, 2, ',', '.'));
  $('#gesamt-aufteilung').html(numberFormat(sumHl, 2, ',', '.'));
};

/**
 * aufteilungBrueheTankfuellung_bind
 */
window.aufteilungBrueheTankfuellung_bind = function() {
  aufteilungBrueheTankfuellung_updateAufteilung();

  $('#vorschlag-fields input').on('keyup change paste', function() {
    aufteilungBrueheTankfuellung_updateAufteilung();
  });
};

/**
 * renderMittelanfrage
 * @param element
 * @param anfrageType
 */
window.renderMittelanfrage = function(element, anfrageType) {
  $(element).append('<div class="mittelanfrage" onclick="openMittelanfrage(\'' + anfrageType + '\'); return false;">' + LANG_STRINGS.mittelanfrage + '</div>');
};

/**
 * openMittelanfrage
 * @param anfrageType
 */
window.openMittelanfrage = function(anfrageType) {
  const autocompleteName = (document.getElementById('mittel-psmID')).getAttribute('aria-controls');
  document.getElementById(autocompleteName).remove();
  ajaxDialog(BASE_PATH + 'ajax/dialog/aufzeichnungen/ajax.mittelanfrage?anfrageType=' + anfrageType);
};

/**
 * mittelanfrageCheckType
 */
window.mittelanfrageCheckType = function() {
  const mittelType = $('#request-mittelType option:selected').val();

  if (mittelType === 'psm') {
    $('.onlyDuenge').hide();
    $('.onlyPsm').show();
  } else {
    $('.onlyDuenge').show();
    $('.onlyPsm').hide();
  }
};

/**
 * summiereFlaeche
 * @param abschnitte
 * @returns {*}
 */
window.summiereFlaeche = function(abschnitte) {
  return abschnitte.reduce((a, b) => a + b.flaeche, 0.0);
};

/**
 * mapReduceAbschnitte
 * @param abschnitte
 * @param mapper
 * @returns {*}
 */
window.mapReduceAbschnitte = function(abschnitte, mapper) {
  return mapReduce(abschnitte, mapper, a => a.id);
};

/**
 * mapReduce
 * @param list
 * @param mapper
 * @param keyExtractor
 * @returns {*}
 */
window.mapReduce = function(list, mapper, keyExtractor) {
  return list.map(item => mapper(item)).reduce((all, current) => ({
    ...all,
    [keyExtractor(current)]: current,
  }), {});
};

/**
 * duengeplan_sendForm
 * @param element
 */
window.duengeplan_sendForm = function(element) {
  $(element).closest('form').submit();

  setTimeout(function() {
    ajaxDialog('close');
  }, 100);
};
